import { Spin } from "antd";

const LoadingSpinner = ({ size = "large", minHeight = "0px" }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin size={size} />
    </div>
  );
};

export default LoadingSpinner;
